import {Datagrid, Filter, FunctionField, TextField, TextInput, TopToolbar} from "react-admin";
import React from "react";
import CrudMod from "../../../Component/Layouts/Button/CrudMod";
import CreateGradientButtonMod from "../../../Component/Layouts/Button/CreateGradientButtonMod";
import ListMod from "../../../Component/Redesign/ListMod";
import {convertedDate} from "../../../Functions/ConvertedDate";

const Filters = (props) => (
    <Filter {...props}>
        <TextInput variant="standard" label="Search" source="search" alwaysOn/>
    </Filter>
);

const TypeField = ({record}) => {
    if (!record.types || !record.types.length) {
        return 'None';
    }

    return record.types.map((item, i) => (
        <div key={i}>
            <span>{item.type}</span>
        </div>
    ))
};

const PublishedField = ({record}) => {
    if (!record.published) return 'No';
    return (
        <span>{record.published === 1 && 'Yes'}</span>
    );
}

const LocalsField = ({record}) => {
    if (!record.locales || !record.locales.length) {
        return '';
    }

    const lastElement = record.locales.length - 1;
    return record.locales.map((item, i) => (
        <span key={i}>{item.locale}{i === lastElement ? '' : ', '}</span>
    ))
};

export const SuccessStories = (props) => {
    const ListActions = ({className}) => {
        return (<TopToolbar className={className}>
            <div className="actionsWrap">
                <div className="addCategoryBtnWrap">
                    <CreateGradientButtonMod label={'Add New Success Story'}/>
                </div>
            </div>
        </TopToolbar>);
    };

    return (
        <div className="customTableWrap">
            <ListMod {...props} title="Success Stories" filters={<Filters/>} actions={<ListActions/>} resource="success-stories/general"
                     sort={{field: 'order', order: 'ASC'}}>
                <Datagrid bulkActionButtons={false} className="customTable files-table">
                    <FunctionField label="Create Date" source="created_at" sortBy="created_at" render={(record) => {
                        if (!record.created_at) return <></>;
                        return (convertedDate(record.created_at));
                    }}/>
                    <FunctionField label="Name" source="name" sortBy="name" render={(record) => {
                        return <span title={record.name}>{record.name}</span>;
                    }}/>
                    <FunctionField label='Description' source="description" sortBy="description" render={(record) => {
                        return (
                            <span title={record.description}>{record.description}</span>
                        );
                    }}/>
                    <TextField label='Order' source="order" sortBy="order"/>
                    <FunctionField label="Type" source="types" sortBy="types" render={(record) => {
                        return <TypeField record={record}/>;
                    }}/>
                    <FunctionField label="Visible" source="published" sortBy="published" render={(record) => {
                        return <PublishedField record={record}/>;
                    }}/>
                    <FunctionField label="Localization" source="locales" sortBy="locales" render={(record) => {
                        return <LocalsField record={record}/>;
                    }}/>
                    <FunctionField label="" source="actions" render={(record) => {
                        return <CrudMod edit="true" del="true" id={record.id} record={record}/>;
                    }}/>
                </Datagrid>
            </ListMod>
        </div>
    )
}

export default SuccessStories;
